import {CommonModule, NgOptimizedImage} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatRadioModule} from '@angular/material/radio';
import {RouterModule} from '@angular/router';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {MarkdownComponent, provideMarkdown} from 'ngx-markdown';
import {CoreModule} from '../common/service';
import {ApiModule} from '../data/api/api.module';
import {AddressApiService} from '../data/api/service';
import {SeFeComponentsModule} from '../se-fe-components.module';
import {TaxAndShippingModule} from '../tax-and-shipping/tax-and-shipping.module';
import {AddOnEffects} from './add-on.effects';
import * as fromAddOns from './reducers';
import {FailedAddOnsComponent} from './failed-add-ons/failed-add-ons.component';
import {CartModule} from '../common/shopping-cart/cart.module';
import {CommonComponentsModule} from '../common/components/common-components.module';
import {AddonRendererComponent} from './add-on-renderer/addon-renderer.component';
import {RenderTargetDirective} from './add-on-renderer/directives/renderer-target.directive';
import {NoAddonsComponent} from './no-addons/no-addons.component';
import {ServiceOfferComponent} from './service-offer/service-offer.component';
import {CheckboxFormComponent} from './service-offer/components/checkbox-form/checkbox-form.component';
import {RadioFormComponent} from './service-offer/components/radio-form/radio-form.component';
import {SePlayButtonComponent} from './service-offer/components/se-play-button/se-play-button.component';
import {LetDirective} from '@ngrx/component';
import {YsoProductsPageComponent} from './yso-products/yso-products-page.component';
import {YsoProductComponent} from './yso-products/components/yso-product/yso-product.component';
import {YsoProductFormComponent} from './yso-products/components/yso-product-form/yso-product-form.component';
import {YsoProductInfoComponent} from './yso-products/components/yso-product-info/yso-product-info.component';
import {YsoBundleItemComponent} from './yso-products/components/yso-bundle-item/yso-bundle-item.component';
import {SelectFormComponent} from './service-offer/components/select-form/select-form.component';

@NgModule({
  declarations: [
    AddonRendererComponent,
    FailedAddOnsComponent,
    RenderTargetDirective,
    NoAddonsComponent,
    ServiceOfferComponent,
    CheckboxFormComponent,
    SelectFormComponent,
    RadioFormComponent,
    SePlayButtonComponent,
    YsoProductsPageComponent,
    YsoProductComponent,
    YsoProductFormComponent,
    YsoProductInfoComponent,
    YsoBundleItemComponent,
  ],
  providers: [AddressApiService, provideMarkdown()],
  imports: [
    ApiModule,
    CartModule,
    CommonModule,
    CommonComponentsModule,
    CoreModule,
    EffectsModule.forFeature([AddOnEffects]),
    LetDirective,
    MarkdownComponent,
    MatRadioModule,
    ReactiveFormsModule,
    RouterModule,
    SeFeComponentsModule,
    StoreModule.forFeature(fromAddOns.addOnFeatureKey, fromAddOns.reducers),
    TaxAndShippingModule,
    NgOptimizedImage,
  ],
})
export class AddOnModule {}
